import { Component, HostListener, Input } from '@angular/core';
import { News, Organisation, Event } from '../../../models/types';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LoginService } from '../../services/login.service';
import { ActivatedRoute } from '@angular/router';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { EventService } from '../../services/event.service';
import { imageLocation } from '../../../environments/environment.development';
import { GalleryImage, GalleryItemEvent, GalleryModule } from '@daelmaak/ngx-gallery';
import { NewsListComponent } from '../news-list/news-list.component';
import { EventListComponent } from '../event-list/event-list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEnvelope, faHouse, faPhone, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { HttpResponse } from '@angular/common/http';
import { ProfilePageService } from '../../services/profile-page.service';
import { FormsModule } from '@angular/forms';
import { ReportListComponent } from '../report-list/report-list.component';

@Component({
  selector: 'app-firedepartment-page',
  standalone: true,
  imports: [CommonModule, GalleryModule, NewsListComponent, EventListComponent, FontAwesomeModule, FormsModule, NgOptimizedImage, ReportListComponent],
  templateUrl: './firedepartment-page.component.html',
  styleUrl: './firedepartment-page.component.scss'
})
export class FiredepartmentPageComponent {
  @Input() organisation: Organisation | null = null;
  @Input() isSuperAdmin: boolean = false;

  news: News[] = [];
  isOrgAdmin: boolean = false;
  isLoading: boolean = true;
  error: string | null = null;
  organisationId: string = '';
  allEvents: Event[] = [];
  imageSelected = false;
  selectedImageIndex = -1;
  currentPage: number = 1;
  pageSize: number = 4;
  totalItems: number = 0;

  faHouse = faHouse;
  faPhone = faPhone;
  faEnvelope = faEnvelope;
  faPlus = faPlus;
  faTrash = faTrash;

  menuOpen = false;
  fireImages: GalleryImage[] = [];
  showAddLeaderForm = false;
  
  JoinFileUrl = `${imageLocation}/static/content/firedepartment/pristopna_izjava.pdf`;

  newLeader = {
    leaderID: 0,
    role: '',
    name: '',
    email: '',
    phone: '',
    imageRef: '',
    organisationID: 0
  }
    constructor(
      private loginService: LoginService,
      private route: ActivatedRoute,
      private organisationService: OrganisationServiceService,
      private eventService: EventService,
      private profilePageService: ProfilePageService,
    ) { }

  ngOnInit() {
    this.isOrgAdmin = this.loginService.IsOrgAdminLoggedIn("fire") 
    //this.extractOrganisationId();
    this.extractOrganisationIdFromName(); 
    this.handleScroll();
  }

  extractOrganisationId() {
    this.route.paramMap.subscribe(params => {
      this.organisationId = params.get('orgID')!;
    });
  }

  extractOrganisationIdFromName() {
    this.organisationService.getOrganisationIdByName("Prostovoljno Gasilsko Društvo Hotedršica").subscribe({
      next: (response) => {
        this.organisationId = response.body?.organisationID.toString() || '';
        this.loadEvents();
        this.getNews();
        this.fetchOrgImages();
      },
      error: (err) => {
        console.error('Error extracting organisation ID:', err);
      }
    });
  }

  @HostListener('window:scroll', [])
  handleScroll() {
    const images = document.querySelectorAll('.animated-image') as NodeListOf<HTMLElement>;
    const titles = document.querySelectorAll('.animated-title') as NodeListOf<HTMLElement>;
    const texts = document.querySelectorAll('.animated-text') as NodeListOf<HTMLElement>;

    this.animateOnScroll(images, 'left-image', 'slide-in-left');
    this.animateOnScroll(images, 'right-image', 'slide-in-right');
    this.animateOnScroll(titles, '', 'slide-in-left'); // No specific class, so we just add the animation
    this.animateOnScroll(texts, '', 'slide-in-right'); // No specific class, just add the animation
  }
  
  private animateOnScroll(elements: NodeListOf<HTMLElement>, className: string, animationClass: string) {
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        if (className === '' || element.classList.contains(className)) {
          element.classList.add(animationClass);
        }
      }
    });
  }

  loadEvents() {
    this.eventService.getAllEvents().subscribe((response) => {
      this.allEvents = response.events!.filter((event: Event) => event.organisationID === Number(this.organisationId));
    });
  }

  getNews() {
    this.isLoading = true;
    this.organisationService.getPaginatedNews(this.currentPage, this.pageSize, this.organisationId).subscribe({
      next: (response) => {
        if (response && Array.isArray(response.news)) {
          const newNews = this.assignNewsImages(response.news);
          this.news = [...this.news, ...newNews]; // Append, don't replace
          this.totalItems = response.total;
        } else {
          this.news = [];
        }
  
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to load news.';
        this.isLoading = false;
      }
    });
  }
  
    
    loadMoreNews() {
      this.currentPage++;
      this.getNews(); // will use the updated page
    }

  private assignNewsImages(news: News[]): News[] {
    return news.map(newsItem => {
      let defaultImageUrl = '../../../assets/images/generic/news.png';
      newsItem.imageRef = newsItem.imageRef ?
      `${imageLocation}/static/content/news/${newsItem.newsID}/${newsItem.imageRef}` :
      defaultImageUrl;
      return newsItem;
    })
  }

    onThumbClick(event: GalleryItemEvent) {
      this.selectedImageIndex = event.index;
      this.imageSelected = true;
      console.log(`Selected image index: ${this.selectedImageIndex}`);
    }

    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }

    scrollTo(sectionId: string) {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      this.menuOpen = false;
    }
    openJoinFile(): void {
      // Open the file in a new tab
      window.open(this.JoinFileUrl, '_blank');
    }

  deleteSelectedImage() {
    if (this.selectedImageIndex !== null) {
      Swal.fire({
        title: 'Ali želite nadaljevati?',
        text: 'Ali želite izbrisati sliko?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da, izbriši!',
        cancelButtonText: 'Ne, prekliči!'
      }).then((result) => {
        if (result.isConfirmed) {
          const imageToDelete = this.fireImages[this.selectedImageIndex];
          const pictureSrc = imageToDelete.src;
  
          this.organisationService.deleteOrgImage(Number(this.organisationId), pictureSrc).subscribe({
            next: (response: HttpResponse<any>) => {
              console.log('Image deleted successfully:', response);
              this.fireImages.splice(this.selectedImageIndex, 1); // Remove image from the gallery
              this.selectedImageIndex = -1;
              this.imageSelected = false;
              // You might want to update the UI or use Angular's change detection instead of reloading the page
              // window.location.reload();
            },
            error: (err) => {
              console.error('Failed to delete image:', err);
            }
          });
        } else {
          console.log('Image deletion cancelled');
        }
      });
    } else {
      console.log('No image selected for deletion');
    }
  }

  openAddSportsImagesModal() {
    this.profilePageService.openOrgImageAddModal(this.organisation!);  
  }

  fetchOrgImages() {
    this.organisationService.getOrganisationImages(this.organisation!.organisationID).subscribe({
      next: (response) => {
        this.fireImages = response.body?.images.map((image: any) => {
          return new GalleryImage(
            `${imageLocation}/static/content/organizations/${this.organisationId}/${image}`,
            `${imageLocation}/static/content/organizations/${this.organisationId}/${image}`,
          );
        }) || []; // Fallback to empty array if response.body is null
      },
      error: (err) => {
        console.error('Failed to fetch organisation images:', err);
      }
    });
  } 

  deleteLeader(id: number) {
    this.organisationService.deleteLeader(id).subscribe({
      next: (response) => {
        console.log('Leader deleted:', response);
      },
      error: (err) => {
        console.error('Error deleting leader:', err);
      }
    });
  }
  
  onSubmitAddLeader() {
    this.newLeader.organisationID = parseInt(this.organisationId);
    if (this.newLeader.name && this.newLeader.role && this.newLeader.email && this.newLeader.phone && this.newLeader.organisationID) {
      this.organisationService.addLeader(this.newLeader).subscribe({
        next: (response) => {
          this.newLeader = { leaderID: 0, role: '', name: '', email: '', phone: '', imageRef: '', organisationID: 0 };
          Swal.fire({
            title: 'Uspešno dodano!',
            text: 'Vodja uspešno dodan! Prosim osvežite stran, da vidite spremembe.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        },
        error: (error) => {
          console.error('Error adding leader:', error);
        }
      });
    } else {
      console.log('Please fill in all required fields.');
    }
  }

  toggleAddLeaderForm() {
    this.showAddLeaderForm = !this.showAddLeaderForm;
  }

  handleNewsChanged() {
    this.news = [];
    this.currentPage = 1;
    this.getNews();
  }

  handleEventChanged() {
    this.allEvents = [];
    this.currentPage = 1;
    this.loadEvents();
  }
  
}
